import styled from 'styled-components'

export default styled.h2`
  color: #640000;
  text-shadow: 1px 1px 0 #fff;
  font-size: 1.7rem;
`
